export default __webpack_public_path__ + "static/media/640_business02-jp-mobile.a3680720.png";